import { Component, OnInit } from '@angular/core';
import { HttpModule, Headers, RequestOptions, Jsonp } from '@angular/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Subject } from "rxjs/Rx";

// Service
import { LoginService } from '../service/login.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	providers: [
		HttpModule
	]
})
export class LoginComponent implements OnInit {

	nameUser = '';
	passUser = '';
	private token;
	private code: string = "";
	private ccid: string = "";

	/**
	* Método construtor
	* @param loginService: LoginService
	*/
	constructor(private jsonp: Jsonp, private loginService: LoginService, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService) {
		this.token = localStorage.getItem('yara.token');

		if (this.token) {
			this.route.params.subscribe(params => {
				this.ccid = params['ccid'];

				if (this.ccid) {
					this.router.navigateByUrl('/conta-cliente/codigo/' + this.ccid);
				} else {
					this.router.navigateByUrl('/cockpit');
				}
			});
		}
	}

	ngOnInit() {
		$("header").hide();

		this.route.params.subscribe(params => {
			this.code = params['code'];
			this.ccid = params['ccid'];

			if (this.ccid) {
				localStorage.setItem('yara.previousPage', '/conta-cliente/codigo/' + this.ccid);
			}

			if (this.code) {
				this.loginUser("", "", this.code);
			}
		});
	}

	loginUser(user, pass, code) {
		var data;

		if (code) {
			var referrer = sessionStorage.getItem('yara.Referrer');
			
			var r = (referrer.indexOf('/partner') >= 0) ? "1" : "0";
			var version = (referrer.indexOf('yaraamericas') > 0) ? "v2" : "v1";
			
			data = "grant_type=password&code=" + code + "&r=" + r + "&version=" + version;
		} else {
			data = "grant_type=password&username=" + user + "&password=" + pass;
		}

		this.loginService.login(data).subscribe(result => {
			var now = new Date();
			now.setSeconds(now.getSeconds() + parseInt(result.expires_in) - 60);

			localStorage.setItem('yara.token', result.access_token);
			localStorage.setItem('yara.token_expires', now.toString());

			this.token = localStorage.getItem('yara.token');

			this.setConnectionHeader(1); // load user info now...
		}, error => {
			this.flashMessagesService.show(JSON.parse(error._body).error_description, { cssClass: 'alert-danger', timeout: 6000 });
		});
	}

	getUserInfo() {
		this.loginService.getUserInfo(this.token).subscribe(result => {
			if (result.Success) {
				console.log("User Info:", result);

				localStorage.setItem('yara.userName', result.Result.Nome);
				localStorage.setItem('yara.companyPermission', result.Result.EmpresasID);
				localStorage.setItem('yara.selectedCompany', result.Result.EmpresaLogada);
				localStorage.setItem('yara.userID', result.Result.ID);
				localStorage.setItem('yara.tokenID', result.Result.TokenID);

				this.setConnectionHeader(2); // load user permissions and update header now...
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			this.flashMessagesService.show(JSON.parse(error._body).error_description, { cssClass: 'alert-danger', timeout: 6000 });
			console.log(error);
		});
	}

	getPermissions() {
		var token = localStorage.getItem('yara.token');

		if (token) {
			this.loginService.getPermissons(token).subscribe(result => {
				localStorage.setItem('yara.permissions', JSON.stringify(result));
				this.loginService.permissionsLoaded.next(true);
			}, error => {
				console.log(error);
			});
		}
	}

	// loadLevel: (0: nothing, 1: user, 2: permissions, 3: user + permission)
	setConnectionHeader(loadLevel: number) {
		this.jsonp.get('//api.ipify.org/?format=jsonp&callback=JSONP_CALLBACK').subscribe(response => {
			const headerIP = response["_body"].ip;
			
			let headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
			headers.append('Navegador', navigator.userAgent);
			headers.append('IP', headerIP);
			headers.append('Pagina', window.location.origin);
			headers.append('Idioma', navigator.language);

			if (loadLevel & 2) {
				headers.append('TokenID', localStorage.getItem('yara.tokenID'));
			}

			let options = new RequestOptions({ headers: headers });
			localStorage.setItem('yara.connectionHeader', JSON.stringify(options));

			if (loadLevel & 1) {
				this.getUserInfo();
			}
			if (loadLevel & 2) {
				this.getPermissions();
			}
		}, error => {
			console.log(error);
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/login/component/login.component.ts